import { writable } from 'svelte/store';
import { UserAgentUtil } from "../lib/Common/UserAgent/UserAgentUtil";
export var EnvStore;
(function (EnvStore) {
    EnvStore.type = writable(null);
    function isProd(type) {
        switch (type) {
            case 'local':
            case 'develop':
            case 'staging':
            case 'stg':
                return false;
        }
        return true;
    }
    EnvStore.isProd = isProd;
    // アクセスした端末の OS
    EnvStore.osType = writable(UserAgentUtil.OsType.None);
    function isSmartPhone(osType) {
        switch (osType) {
            case UserAgentUtil.OsType.Android:
            case UserAgentUtil.OsType.iOS:
                return true;
            default:
                return false;
        }
    }
    EnvStore.isSmartPhone = isSmartPhone;
})(EnvStore || (EnvStore = {}));
